module.exports = __webpack_public_path__ + "img/muyu_des_1.27649fd1.jpg";